import React from 'react';
import './ProjectCard.css';

export const ProjectCard = (props) => {
    return(
        <div className='project-card'>
            <div className='project-card__left'>
                <img src={props.image} alt={props.alt} />
            </div>
            <div className='project-card__right'>
                <h2>{props.title}</h2>
                <p>{props.description}</p>
                <a href={props.link} target="_blank">{props.linkName}</a>
            </div>
        </div>
    )
};


// WEBPACK FOOTER //
// ./src/components/content-container/project-card/ProjectCard.jsx